import React from "react";
import { Stack, IconButton, Spinner } from "@fluentui/react";
import ReactMarkdown from "react-markdown";
import remarkGfm from 'remark-gfm';
import rehypeRaw from "rehype-raw";
import { AISearchRAGCitation_Parsed } from "../../api";
import styles from "./Chat.module.css";

interface CitationPanelProps {
    activeCitation: AISearchRAGCitation_Parsed;
    onClose: () => void;
    onViewSource: (citation: AISearchRAGCitation_Parsed) => void;
    urlBlobMap: Map<string, string>;
    loadingBlobs: Set<string>;
}

export const CitationPanel: React.FC<CitationPanelProps> = ({
    activeCitation,
    onClose,
    onViewSource,
    urlBlobMap,
    loadingBlobs
}) => {
    return (
        <Stack.Item className={styles.citationPanel} tabIndex={0} role="tabpanel" aria-label="Citations Panel">
            <Stack 
                aria-label="Citations Panel Header Container" 
                horizontal 
                className={styles.citationPanelHeaderContainer} 
                horizontalAlign="space-between" 
                verticalAlign="center"
            >
                <span aria-label="Citations" className={styles.citationPanelHeader}>
                    引用元{activeCitation.page ? `（${activeCitation.page}ページ）` : ""}
                </span>
                <IconButton 
                    iconProps={{ iconName: 'Cancel'}} 
                    aria-label="Close citations panel" 
                    onClick={onClose}
                />
            </Stack>
            <h5 
                style={{color: "blue", textDecoration: "underline"}} 
                className={styles.citationPanelTitle} 
                tabIndex={0} 
                title={activeCitation.url && !activeCitation.url.includes("blob.core") ? activeCitation.url : activeCitation.title ?? ""} 
                onClick={() => onViewSource(activeCitation)}
            >
                {activeCitation.title}
            </h5>
            {
                activeCitation?.url && urlBlobMap.has(activeCitation.url) ?
                <object 
                    // Chromium系で、URLが変わらずフラグメントが変更されたときに、再レンダリングが走らないというバグがあるらしいので、keyによって再レンダリングを走らせる
                    key={activeCitation.url + `#page=${activeCitation.page}&navpanes=0`}
                    data={urlBlobMap.get(activeCitation.url) + `#page=${activeCitation.page ?? 1}&navpanes=0`} 
                    width="100%" 
                    height="100%"
                >
                </object>
                :
                <div tabIndex={0}> 
                    {activeCitation.url && loadingBlobs.has(activeCitation.url) ? <Spinner /> : <></>}
                    <ReactMarkdown 
                        linkTarget="_blank"
                        className={styles.citationPanelContent}
                        children={activeCitation.content} 
                        remarkPlugins={[remarkGfm]} 
                        rehypePlugins={[rehypeRaw]}
                    />
                </div>
            }
        </Stack.Item>
    );
};